import React from "react"
import "./arrow.scss"
import PropTypes from "prop-types"


const Arrow = ({ direction, handleClick, classNameOuter }) => {
  let classNameRound = direction === "left" ? "round left" : "round right"
  return (
    <div
      className={`${classNameRound} ${classNameOuter}`}
      role="button"
      onClick={handleClick}
    >
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M9.7187 5.0312C9.93842 4.81174 10.2363 4.68848 10.5468 4.68848C10.8574 4.68848 11.1552 4.81174 11.3749 5.0312L18.0156 11.6718C18.235 11.8915 18.3583 12.1894 18.3583 12.4999C18.3583 12.8105 18.235 13.1083 18.0156 13.3281L11.3749 19.9687C11.1528 20.1757 10.859 20.2884 10.5554 20.283C10.2518 20.2777 9.96212 20.1547 9.74741 19.94C9.5327 19.7253 9.40972 19.4356 9.40436 19.132C9.399 18.8284 9.5117 18.5346 9.7187 18.3124L15.5312 12.4999L9.7187 6.68745C9.49924 6.46772 9.37598 6.16987 9.37598 5.85932C9.37598 5.54877 9.49924 5.25092 9.7187 5.0312Z"
              fill="#3F4158" />
      </svg>

    </div>
  )
}

export default Arrow

Arrow.defaultProps = {
  handleClick: () => {
  },
  direction: "right",
  classNameOuter: ""
}

Arrow.propTypes = {
  handleClick: PropTypes.func,
  direction: PropTypes.string,
  classNameOuter: PropTypes.string
}
